import React from "react";
import './packEntrepreneur.css'

const PackEntrepreneur = (props) => {
  let { price, fakePrice, label} = props.upsellInfo
  const {checkedUpsell} = props
  price = price ? `${price}€` : '32€'
  fakePrice = fakePrice ? `${fakePrice}€` : '49€'
  label = label || 'Pack Entrepreneur'
  return(
    <div className="condition-box">
      <div className="cbx-head">
        <p className="ch-title packTitle">{label}</p>
        <div className="priceWrapper">
          <label htmlFor="check9">
            <input className="priceCheckBox" type="checkbox" onClick={() => props.toggleUpsell(props.index)} checked={checkedUpsell}/>
            <span className="packPrice">{`+${price}`} </span>
            <span className="chbx-txt oldPrice">{fakePrice} </span>
          </label>
        </div>
      </div>
      <div className="packContent">
        <p>
          Ce pack contient l'ensemble des éléments utiles aux entrepreneurs afin qu'ils puissent correctement exercer leur activité.
        </p>
        <p>
          Vous pouvez prendre ce pack plus tard mais le tarif réduit de {price} ne sera plus applicable. Le Pack Entrepreneur est valable 2 mois à partir de la date d'achat.
        </p>
        <h4 className="packOption">Assistance Entrepreneur</h4>
        <p>
          Très rapidement, les entrepreneurs sont confrontés à de nombreuses problématiques. Grâce à l'assistance Entrepreneur, vous bénéficiez d'un accès privilégié à notre expertise pour répondre à toutes vos inquiétudes :
        </p>
        <ul>
          <li>Comment gérer mon entreprise ?</li>
          <li>Comment gérer ma comptabilité ?</li>
          <li>Comment facturer mes clients ?</li>
          <li>Comment calculer mon tarif ?</li>
          <li>Comment déclarer mes impôts ?</li>
          <li>Comment prospecter des clients ?</li>
          <li>Quel compte bancaire choisir ?</li>
        </ul>
        <h4 className="packOption">Contrats personnalisés</h4>
        <p>
          Pendant 2 mois, vous avez un accès illimité à notre générateur de contrats personnalisés.
          C'est un outil très puissant permettant d'obtenir des contrats mis à jour. Il vous suffit simplement de répondre à un questionnaire en ligne.
        </p>
        <p>
          Exemples : contrats freelance, contrats de prestation de service, accord de confidentialité (NDA), etc.
        </p>
        <h4 className="packOption">Modèles de devis et factures</h4>
        <p>
          Nous vous fournissons des templates de devis et de factures pré-remplis et aux normes.
        </p>
      </div>
    </div>
  )
}
export default PackEntrepreneur;



// WEBPACK FOOTER //
// ./src/components/buy/upsell/pack-entrepreneur.js